import { render, staticRenderFns } from "./OtpLogin.vue?vue&type=template&id=67ba601e&scoped=true&"
import script from "./OtpLogin.vue?vue&type=script&lang=js&"
export * from "./OtpLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ba601e",
  null
  
)

export default component.exports